import React, { useState, useEffect } from 'react';
import { Input } from 'antd';
import { format, validate } from 'rut.js';

const RutInput = ({ 
  value, 
  onChange, 
  onBlur, 
  onValidRut, // Nueva prop para callback cuando RUT es válido
  autoFetch = false, // Nueva prop para activar búsqueda automática
  size = "middle", // Prop para tamaño consistente
  ...props 
}) => {
  const [displayValue, setDisplayValue] = useState('');
  const [isValid, setIsValid] = useState(false);
  
  console.log('🔍 RutInput - value prop:', value);
  console.log('🔍 RutInput - displayValue state:', displayValue);

  // Formatear el valor inicial
  useEffect(() => {
    if (value !== undefined && value !== null) {
      const cleanValue = String(value).replace(/[^0-9kK]/g, '');
      if (cleanValue) {
        const formattedValue = format(cleanValue);
        setDisplayValue(formattedValue);
        setIsValid(validate(cleanValue));
      } else {
        setDisplayValue('');
        setIsValid(false);
      }
    } else {
      setDisplayValue('');
      setIsValid(false);
    }
  }, [value]);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    
    // Limpiar el input de caracteres no válidos
    const cleanedValue = inputValue.replace(/[^0-9kK]/g, '');
    
    // Formatear el RUT
    const formattedValue = format(cleanedValue);
    
    setDisplayValue(formattedValue);
    
    // Validar RUT
    const valid = validate(cleanedValue);
    setIsValid(valid);
    
    // Pasar el valor FORMATEADO al onChange
    if (onChange) {
      onChange({
        ...e,
        target: {
          ...e.target,
          value: formattedValue // Cambiado de cleanedValue a formattedValue
        }
      });
    }
  };

  const handleBlur = (e) => {
    const cleanedValue = displayValue.replace(/[^0-9kK]/g, '');
    const valid = validate(cleanedValue);
    
    // Si no es válido, limpiar el campo
    if (!valid && cleanedValue) {
      setDisplayValue('');
      setIsValid(false);
      if (onChange) {
        onChange({
          ...e,
          target: {
            ...e.target,
            value: ''
          }
        });
      }
    } else if (valid) {
      // Si es válido, asegurar que el valor formateado se pase
      const formattedValue = format(cleanedValue);
      if (onChange) {
        onChange({
          ...e,
          target: {
            ...e.target,
            value: formattedValue
          }
        });
      }
      // Si autoFetch está activado, llamar al callback
      if (autoFetch && onValidRut) {
        onValidRut(cleanedValue);
      }
    }
    
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <Input
      {...props}
      size={size}
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder="12345678-9"
      maxLength={12} // Formato máximo: 12345678-9
      status={isValid ? 'success' : undefined}
    />
  );
};

export default RutInput; 